import { getJioBannerListingUrl, getJioAdsParsedResponse } from '../../utils/jioAdsRelated';
import fetcher from '../../modules/ajio-fetch';
import _toLower from 'lodash/toLower';
import get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { fetchGetJSONReqOpts, fetchGetJSONResHandler, getFetcherHeader } from '../../modules/ajio-fetch/utils';
import { SET_JIO_BANNER_ADS } from '../../constants/constant';
import isNode from '../../modules/ajio-util/isNode';
import { readCohortValueCookie, readCohortValueCookieAtNode, readCookie } from '../../components/common/Cookie.js';
import { sha256Hex } from '../../utils/products';

import { FETCH_CMS_ADS_REQUEST, FETCH_CMS_ADS_SUCCESS, FETCH_CMS_ADS_FAILURE } from "../../actions/cmsAdsAction";

const endpoints = require('../../modules/ajio-util/endpoints');

let cachedProxyAgent;
function getProxyAgent() {
  if (cachedProxyAgent) return cachedProxyAgent;
  if (!isNode()) {
    return undefined;
  }

  const env = get(process, 'env.NODE_CONFIG_ENV', 'production');
  const envLower = env.toLowerCase();
  try {
    // Import the module dynamically to prevent webpack from bundling it
    const proxyModule = module.require('https-proxy-agent');
    const { HttpsProxyAgent } = proxyModule;
    if (envLower.includes('replica') || envLower.includes('uat52')) {
      cachedProxyAgent = new HttpsProxyAgent('http://lwproxy.jio.com:8080');
    } else if (envLower.includes('gcp')) {
      cachedProxyAgent = new HttpsProxyAgent('http://gcpprodproxy.jio.com:8080');
    }
  } catch (error) {
    return undefined;
  }
  return cachedProxyAgent;
}

export function fetchJioBannerAds(values, facetValue = '', error = '') {
  return {
    type: SET_JIO_BANNER_ADS,
    values,
    error,
    facetValue
  };
}
export function initJioAds(
  jioAdsRelevantFacets,
  userAgent = '',
  userType = 'non_premium',
  sis = 'ajio',
  deviceType = 'phone',
  vr = 'web-2.0.10',
  addressParameters = {}
) {
  return dispatch => {
    const jioAdsURL = getJioBannerListingUrl({
      md_ajiocat: jioAdsRelevantFacets || '',
      ua: userAgent,
      md_utype: userType,
      md_sis: sis.toLowerCase(),
      os: deviceType === 'phone' || deviceType === 'tablet' ? '3' : '4',
      vr,
      md_pc: addressParameters?.pincode,
      md_zone: addressParameters?.PG,
      md_state: addressParameters?.ST
    });
    return fetcher(jioAdsURL.href,  fetchGetJSONReqOpts({
        method: 'GET',
      }))
      .then(res => {
        if (!res.ok) {
          throw new Error('Failed in response ok');
        }

        return res.json();
      })
      .then(res => {
        if (res.success === false) {
          throw new Error(res.errors[0].errorMsg);
        }
        const adsData = getJioAdsParsedResponse(res);

        return dispatch(fetchJioBannerAds(adsData, jioAdsRelevantFacets));
      })
      .catch(err => {
        let message = '';
        if (typeof err === 'string') {
          message = err;
        } else {
          message = err.message;
        }
        return dispatch(fetchJioBannerAds([], jioAdsRelevantFacets, message));
      });
  };
}

function extractValidBanners(response) {
  if (!response || typeof response !== 'object') return [];
  if (!response?.status || response?.status?.statusCode !== 0) return [];

  return (
    response?.data?.component?.banners?.filter(
      banner =>
        banner &&
        (banner?.bannerType === 'AD' ||
          banner?.bannerType === 'EXTERNAL_AD' ||
          (banner?.bannerType === 'IMAGE' && banner?.bannerUrl))
    ) || []
  );
}

async function fetchCMSAdsData(
  req,
  apiUrl = '',
  cmsUserGroup = '',
  cmsUserSubGroup = '',
  storeVal = 'AJIO',
  CMSExperiments = 'ALL',
  enableRushDelivery = false
) {
  if (isNode()) {
    const userTypeNew = getUserType(req);
    const userType = userTypeNew ? 'new' : 'existing';
    const { device: { client_type = '' } = {} } = req;
    const userTypeStatus = !req?.cookies?.U || req.cookies.U === 'anonymous';
    const userStatus = userTypeStatus ? 'NON_LOGGED_IN' : 'LOGGED_IN'
    const isMobile = true;
    const platform = 'MOBILE';
    const channel = 'MSITE';
    const { PC: pincode = '' } = req?.cookies || {};
    let apiEndPoint = `${endpoints.get('cmsComponent')}?` +
      `store=${storeVal}&` +
      `platform=${platform}&` +
      `userStatus=${userStatus}&` +
      `userType=${userType}&` +
      `tenantId=AJIO&` +
      `channel=${channel}&` +
      `url=${apiUrl}&` +
      `experiments=${CMSExperiments}`;

    if (userStatus === 'LOGGED_IN' && cmsUserGroup.length > 0 && cmsUserSubGroup.length > 0) {
      apiEndPoint += `&userGroup=${cmsUserGroup}&userSubGroup=${cmsUserSubGroup}`;
    }
    if (enableRushDelivery && pincode) {
      apiEndPoint = `${apiEndPoint}&pincode=${pincode}`;
    }
  
    const headerInfo = getFetcherHeader(req);
    try {
      const response = await fetcher(apiEndPoint, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          ...headerInfo
        }
      });
      return response;
    } catch (error) {
      console.error('Error fetching CMS Ads data:', error);
      throw error;
    }
  }
}

function mergeApiResponses(cmsResponse, jioAdsResponse, cmsAdSize) {
  if (!Array.isArray(cmsResponse) || !Array.isArray(jioAdsResponse)) return [];

  if (jioAdsResponse.length === 0) {
    return cmsResponse.filter(banner => banner?.bannerType !== 'AD');
  }

  const adUsageTracker = new Set(); // Track used ads from jioAdsResponse

  const mergedData = cmsResponse.map(banner => {
    if (!banner || typeof banner !== 'object') return banner;

    if (banner?.bannerType === 'AD') {
      // Find the first unused matching ad
      const matchingAdIndex = jioAdsResponse.findIndex(
        (ad, index) =>
          !adUsageTracker.has(index) &&
          ad?.wt === banner?.adSpotId &&
          ad?.customimage &&
          Array.isArray(ad.customimage) &&
          ad.customimage[0]?.[cmsAdSize]
      );

      if (matchingAdIndex === -1) {
        return null;
      }

      const matchingAd = jioAdsResponse[matchingAdIndex];
      adUsageTracker.add(matchingAdIndex); // Mark this ad as used

      return {
        ...matchingAd,
        ...banner,
        bannerUrl: matchingAd.customimage[0]?.[cmsAdSize],
        width: banner?.width,
        height: banner?.height
      };
    }

    if(banner?.bannerType === 'EXTERNAL_AD') return null;
    return banner;
  }).filter(item => item !== null);

  return mergedData;
}

function timeout(ms = 1000) {
  return new Promise(resolve => setTimeout(() => resolve({ timedOut: true }), ms));
}

export function fetchCMSBannerAds(
  req,
  pageType = '',
  apiUrl = '',
  isJioAdsEnabled = false,
  jioAdsAsi = '',
  jioAdsSpecs = {},
  jioAdsPageUrl = '',
  userGroup = '',
  cmsAdSize = '',
  storeVal = 'AJIO',
  CMSExperiments = 'ALL',
  enableRushDelivery = false
) {
  return async function(dispatch) {
    let customerValueType = 'non_premium';
    let cmsUserGroup = '';
    let cmsUserSubGroup = '';
    if (userGroup && userGroup.length > 0) {
      customerValueType = userGroup.split('|')[0] || '';
      cmsUserGroup = userGroup.split('|')[0] || '';
      cmsUserSubGroup = userGroup.split('|')[1] || '';
    } else {
      customerValueType = get(jioAdsSpecs, 'userGroup', 'non_premium');
    }
    const page = pageType || '';
    dispatch({ type: FETCH_CMS_ADS_REQUEST, payload: { page } });

    try {
      const [cmsAdsResponse, jioAdsResponse] = await Promise.all([
        fetchCMSAdsData(
          req,
          apiUrl,
          cmsUserGroup,
          cmsUserSubGroup,
          storeVal,
          CMSExperiments,
          enableRushDelivery
        ),
        isJioAdsEnabled
          ? fetchJioAds(req, jioAdsAsi, jioAdsSpecs, jioAdsPageUrl, userGroup, customerValueType)
          : Promise.resolve([])
      ]);

      if (!cmsAdsResponse.ok) {
        throw new Error('Failed to fetch CMS Ads data');
      }

      const cmsAdsJson = await cmsAdsResponse.json();
      const validBanners = extractValidBanners(cmsAdsJson);
      console.log('jio ads response', jioAdsResponse);
      const mergedResponse = mergeApiResponses(validBanners, jioAdsResponse, cmsAdSize);

      dispatch({ type: FETCH_CMS_ADS_SUCCESS, payload: { page, adsData: mergedResponse } });
    } catch (err) {
      dispatch({
        type: FETCH_CMS_ADS_FAILURE,
        payload: { page, error: err?.message || 'Failed to fetch CMS ads data' }
      });
    }
  };
}

function getUserType(req) {
  if (!req || typeof req !== 'object') return true;

  let isNewUser = true;

  if (typeof req.url === 'string' && req.url.toLowerCase().includes('user=old')) {
    isNewUser = false;
  } else if (
    req.cookies &&
    typeof req.cookies.customerType === 'string' &&
    req.cookies.customerType.toLowerCase() === 'existing'
  ) {
    isNewUser = false;
  }

  return isNewUser;
}

function getSecondaryCohort(userCohortValue) {
  if (typeof userCohortValue !== 'string') {
    return '';
  }
  const secondaryCohorts = userCohortValue.split('|')[1];
  if (secondaryCohorts) {
    const regex = /[^a-zA-Z0-9,_]/g;
    return secondaryCohorts.replace(regex, '_');
  }
  return '';
}

async function fetchJioAds(
  req,
  jioAdsAsi,
  jioAdsSpecs,
  jioAdsPageUrl,
  userGroup,
  customerValueType
) {
  try {
    //return [];
    const secondaryCohort = getSecondaryCohort(userGroup) || '';
    const userTypeNew = getUserType(req);
    const { sdkParams = {} } = jioAdsSpecs;
    const userAgent = req?.headers['user-agent'] || '';
    const sisValue = req?.store || 'ajio';
    const jioAdsURL = getJioBannerListingUrl({
      isLandingAdBanners: true,
      adSpotId: _toLower(jioAdsAsi),
      md_ajiocat: '',
      ua: _toLower(userAgent),
      md_utype: _toLower(customerValueType),
      md_sis: _toLower(sisValue),
      os: _toLower(sdkParams.os),
      ai: _toLower('www.ajio.com'),
      vr: _toLower(sdkParams.vr),
      ifa: _toLower(sdkParams.ifa || ''),
      md_user_status: !req.cookies.LS ? 'non_logged_in' : 'logged_in',
      md_user_restriction: userTypeNew ? 'new' : 'existing',
      vnm: 'jioads',
      md_platform: 'mobile',
      md_channel: 'MSITE',
      md_page_url: jioAdsPageUrl,
      md_secondaryid: secondaryCohort
    });

    const jioAdsResponse = await Promise.race([
      fetcher(jioAdsURL.href,  fetchGetJSONReqOpts({
        method: 'GET',
      })),
      timeout(jioAdsSpecs.apiTimeoutLimit)
    ]);
    if (jioAdsResponse?.timedOut) {
      throw new Error('Jio Ads API request timed out');
    }
    return getJioAdsParsedResponse(await fetchGetJSONResHandler(jioAdsResponse), jioAdsAsi);
  } catch (err) {
    console.error('Failed to fetch Jio Ads:', err);
    return [];
  }
}

function getOsmosBannerUrl(urlParams) {
  const {
    baseUrl = '',
    sis = 'ajio',
    pageType = '',
    pincode = '',
    userType = 'Existing',
    state = '',
    clientId = '',
    userSecondaryCohort = '',
    cliUbid = '',
    userLoginStatus = 'LOGGED_IN',
    pcntAu = 10,
    platform = 'MOBILE',
    userCohort = '',
    zone = '',
    channel = 'Android',
    city= ''
  } = urlParams;

  const osmosAdsURL = new URL(baseUrl);
    osmosAdsURL.searchParams.set('f.sis', sis);
  if (pageType) osmosAdsURL.searchParams.set('pt', pageType.replace(/[^a-zA-Z0-9]/g, '_'));
  if (pincode) osmosAdsURL.searchParams.set('f.pincode', pincode);
  if (userType) osmosAdsURL.searchParams.set('f.user_type', JSON.stringify([userType]));
  if (state) osmosAdsURL.searchParams.set('f.state', JSON.stringify([state]));
  if (clientId) osmosAdsURL.searchParams.set('client_id', clientId);
  if (userSecondaryCohort)
    osmosAdsURL.searchParams.set('f.user_secondary_cohort', JSON.stringify([userSecondaryCohort]));
  if (cliUbid) osmosAdsURL.searchParams.set('cli_ubid', cliUbid);
  if (userLoginStatus) osmosAdsURL.searchParams.set('f.user_loginstatus', JSON.stringify([userLoginStatus]));
  if (pcntAu) osmosAdsURL.searchParams.set('pcnt_au', pcntAu);
  if (platform) osmosAdsURL.searchParams.set('f.platform', platform);
  if (userCohort) osmosAdsURL.searchParams.set('f.user_cohort', JSON.stringify([userCohort]));
  if (zone) osmosAdsURL.searchParams.set('f.zone', zone);
  osmosAdsURL.searchParams.set('rn', Date.now());
  if (channel) osmosAdsURL.searchParams.set('f.channel', JSON.stringify([channel]));
  if (city) osmosAdsURL.searchParams.set('f.city', JSON.stringify([city]));

  return osmosAdsURL;
}

function signInCheck(getUserId = false) {
  let user;
  let signedIn;
  try {
    user = readCookie('un');
    signedIn = readCookie('U');
  } catch (error) {
    console.log(`Failed to read cookie : ${error}`);
  }
  let username = '';
  if (signedIn && signedIn !== 'anonymous') {
    // sI not being able to read. but can read un?
    // username = this.props.userName; //store is getting empty
    username = getUserId ? decodeURIComponent(signedIn) : decodeURIComponent(user); // store is getting empty so reading from cookie - think of alt
  }
  return username;
}

async function fetchOsmosAds(
  req,
  osmosBannerUrl = '',
  osmosSpecs = {},
  pageType = '',
  userGroup = '',
  customerValueType = '',
  enableUniversalCohortFlow = false,
  userCohortPageType = '',
  sisValue=''
) {
  try {
    const userTypeNew = getUserType(req);
    const userType = userTypeNew ? 'new' : 'existing';
    const secondaryCohort = getSecondaryCohort(userGroup) || '';
    const { PC: pincode = '', ST: state = '', ZN: zone = '',CT: city = '', CI='', segment_device_id='', userCohortValues='' } = req?.cookies || {};
    const userLoginStatus = !req.cookies.LS ? 'NON_LOGGED_IN' : 'LOGGED_IN';
    const clientId = osmosSpecs?.clientId || '';
    const cliUbid = signInCheck() ? sha256Hex(CI) : sha256Hex(segment_device_id);
    const userCohort = readCohortValueCookieAtNode(userCohortValues, sisValue, userCohortPageType, enableUniversalCohortFlow) || '';
    const userPrimaryCohort = userCohort.split('|') || [];
    
    const osmosAdsURL = getOsmosBannerUrl({
      baseUrl: osmosBannerUrl,
      sis: sisValue || 'ajio',
      pageType,
      pincode: pincode,
      userType: userType,
      state: state,
      clientId: clientId,
      userSecondaryCohort: secondaryCohort || 'nogender',
      cliUbid: cliUbid,
      userLoginStatus: userLoginStatus,
      pcntAu: osmosSpecs?.pcntAu || 10,
      platform: 'MOBILE',
      userCohort: userPrimaryCohort[0] || '',
      zone: zone,
      channel: 'Msite',
      city
    });

    const proxyAgent = getProxyAgent() || undefined;

    const osmosAdsResponse = await Promise.race([
      fetcher(osmosAdsURL.href, fetchGetJSONReqOpts({
        method: 'GET',
          ...(proxyAgent ? { agent: proxyAgent } : {})
      })),
      timeout(osmosSpecs.apiTimeoutLimit || 1000)
    ]);
    
    if (osmosAdsResponse?.timedOut) {
      throw new Error('Osmos Ads API request timed out');
    }
    return await fetchGetJSONResHandler(osmosAdsResponse);
  } catch (err) {
    console.error('Failed to fetch Osmos Ads:', err);
    return [];
  }
}



function mergeOsmosApiResponses(cmsResponse, osmosAdsResponse, cmsAdSize) {
  if (!Array.isArray(cmsResponse)) return [];

  const { ads = {} } = osmosAdsResponse;

  if (!ads) {
    return cmsResponse.filter(banner => banner?.bannerType !== 'EXTERNAL_AD');
  }

  // Track used ad indices per adSpotId slot, mirroring the JioAds pattern
  const adUsageTracker = {}; // { [adSpotId]: Set of used indices }

  const mergedData = cmsResponse
    .map(banner => {
      if (!banner || typeof banner !== 'object') return banner;

      if (banner?.bannerType === 'EXTERNAL_AD') {
        if (!(banner.adSpotId in ads)) return null;

        const adSlot = ads[banner.adSpotId];
        if (!Array.isArray(adSlot) || adSlot.length === 0) return null;

        // Initialise the tracker for this adSpotId if not already present
        if (!adUsageTracker[banner.adSpotId]) {
          adUsageTracker[banner.adSpotId] = new Set();
        }

        const usedIndices = adUsageTracker[banner.adSpotId];

        // Find the first unused ad in this slot
        const matchingAdIndex = adSlot.findIndex(
          (ad, index) => !usedIndices.has(index) && ad
        );

        if (matchingAdIndex === -1) return null; // All ads in this slot are exhausted

        const matchingAd = adSlot[matchingAdIndex];
        usedIndices.add(matchingAdIndex); // Mark this ad as used

        const destinationUrl = matchingAd.elements?.destination_url || '';
        const media_type = matchingAd.elements?.media_type || '';

        return {
          ...banner,
          ...matchingAd,
          ...(destinationUrl
            ? {
                hotspots: [{ hotspotUrl: destinationUrl, x: 0, y: 0, width: 100, height: 100 }]
              }
            : {}),
          ...(destinationUrl ? { redirect_url: destinationUrl } : {}),
          bannerUrl: matchingAd.elements?.mobile_image,
          clicktracker: matchingAd?.click_tracking_url || ''
        };
      }

      if (banner?.bannerUrl) return banner;
      return null;
    })
    .filter(item => item !== null);

  return mergedData;
}

export function fetchCMSBannerAdsOsmos(
  req,
  page = '',
  apiUrl = '',
  payload
) {
  const {
    isOsmosEnabled = false,
    osmosBannerUrl = '',
    osmosSpecs = {},
    userGroup = '',
    cmsAdSize = '',
    storeVal = 'AJIO',
    CMSExperiments = 'ALL',
    enableRushDelivery = false,
    pageType = '',
    enableUniversalCohortFlow = false,
    userCohortPageType = ''
  } = payload;
  return async function(dispatch) {
    let customerValueType = 'non_premium';
    let cmsUserGroup = '';
    let cmsUserSubGroup = '';
    if (userGroup && userGroup.length > 0) {
      customerValueType = userGroup.split('|')[0] || '';
      cmsUserGroup = userGroup.split('|')[0] || '';
      cmsUserSubGroup = userGroup.split('|')[1] || '';
    } else {
      customerValueType = get(osmosSpecs, 'userGroup', 'non_premium');
    }
    dispatch({ type: FETCH_CMS_ADS_REQUEST, payload: { page } });

    try {
      const [cmsAdsResponse, osmosAdsResponse] = await Promise.all([
        fetchCMSAdsData(
          req,
          apiUrl,
          cmsUserGroup,
          cmsUserSubGroup,
          storeVal,
          CMSExperiments,
          enableRushDelivery
        ),
        isOsmosEnabled
          ? fetchOsmosAds(req, osmosBannerUrl, osmosSpecs, pageType, userGroup, customerValueType, enableUniversalCohortFlow, userCohortPageType, storeVal)
          : Promise.resolve([])
      ]);

      if (!cmsAdsResponse.ok) {
        throw new Error('Failed to fetch CMS Ads data');
      }

      const cmsAdsJson = await cmsAdsResponse.json();
      const validBanners = extractValidBanners(cmsAdsJson);
      console.log('osmos ads response', osmosAdsResponse);
      const mergedResponse = mergeOsmosApiResponses(validBanners, osmosAdsResponse, cmsAdSize);

      dispatch({ type: FETCH_CMS_ADS_SUCCESS, payload: { page, adsData: mergedResponse } });
    } catch (err) {
      dispatch({
        type: FETCH_CMS_ADS_FAILURE,
        payload: { page, error: err?.message || 'Failed to fetch CMS ads data' }
      });
    }
  };
}
